import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, bool } from 'prop-types'

// One group of menu rows. `divided` draws the leading rule that separates it from
// the previous group (Figma divider between sections).
function Section({ children, divided = false }) {
  return (
    <div className={classnames(
      'unified-nav__dropdown-section',
      divided && 'unified-nav__dropdown-section--divided'
    )}>
      <ul className="unified-nav__dropdown-list">
        {children}
      </ul>
    </div>
  )
}

Section.propTypes = {
  children: node.isRequired,
  divided: bool,
}

export default Section
